export async function getRequiredAuthHeaders(): Promise<{ authorization: string }> {
    const { $auth } = useNuxtApp();
    const token = await $auth.currentUser?.getIdToken();

    if (!token) {
        throw new Error('You need to be signed in to continue.');
    }

    return {
        authorization: `Bearer ${token}`,
    };
}
